// import React from 'react'
// import { connect } from 'react-redux'
// import PlacesAutocomplete, { geocodeByAddress, getLatLng, geocodeByPlaceId } from 'react-places-autocomplete'
// import isNil from 'lodash/isNil'

// class LocationSearch extends React.Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       currentSearch: '',
//       address: '',
//       searchResult: {}
//     }
//     this.marker = null
//     this.getLocation = this.getLocation.bind(this)
//     this.setMarker = this.setMarker.bind(this)
//   }

//   componentDidMount() {
//     const icon = '../../../../../../asset/Marker_Generic_DkGreen@1x.png'
//     this.marker = new google.maps.Marker({
//       options: {
//         draggable: false,
//         clickable: false
//       },
//       icon: { url: icon, scaledSize: new google.maps.Size(35, 35) }
//     })
//   }

//   componentWillUnmount() {
//     this.marker.setMap(null)
//     this.marker = null
//   }

//   setMarker() {
//     const { map } = this.props,
//       { geometry } = this.state.searchResult,
//       location = geometry && geometry.location ? geometry.location : this.state.searchResult
//     // location = { lat: 39.779486, lng: -116.200647 }

//     // 39.779486 -116.200647


//     this.marker.setPosition(location)
//     console.log(location, '===============location')
//     if (isNil(this.marker.getMap())) {
//       this.marker.setMap(map)
//     }
//   }

//   handleChange(e) {
//     this.setState({
//       currentSearch: e
//     })
//   }

//   renderSuggestions(suggestion) {
//     return (
//       <p
//         className='search-result-entry'
//         onClick={this.getLocation}
//         key={suggestion.index}>{suggestion.description}</p>
//     )
//   }

//   getLocation(address, placeId) {
//     if (address && address !== '') {
//       this.setState({ address: address, searching: false }, () => {
//         let placesService = new google.maps.places.PlacesService(this.props.map)
//         if (placeId) {
//           let request = {
//             placeId: placeId,
//             fields: ['name', 'formatted_address', 'geometry', 'icon', 'photos', 'address_components']
//           }
//           placesService.getDetails(request, (results, status) => {
//             if (status == google.maps.places.PlacesServiceStatus.OK) {
//               let latLng = results.geometry.location
//               this.props.map.panTo(latLng)
//               this.props.map.setZoom(15)
//               this.setState({ searchResult: results }, () => {
//                 console.log('set', this.setMarker)
//                 this.setMarker();
//               });
//             } else {
//               console.log('Problem getting place details', status)
//             }
//           });
//         } else {
//           geocodeByAddress(address)
//             .then(results => getLatLng(results[0]))
//             .then(latLng => {
//               this.props.map.panTo(latLng);
//               this.props.map.setZoom(15);
//               this.setState({ currentSearch: address, searchResult: latLng }, () => {
//                 this.setMarker()
//               }
//               );
//             })
//             .catch(error => console.error('Error', error));
//         }
//       })
//     }
//   }

//   getPhotos() {
//     return this.state.searchResult.photos.map(photo => {
//       return (
//         <div style={{
//           backgroundImage: `url(${photo.getUrl()})`,
//           backgroundSize: 'cover',
//           width: '150px',
//           height: '150px',
//           borderRadius: '5px',
//           marginTop: '10px',
//           marginBottom: '10px'
//         }}
//           key={photo.getUrl()}></div>
//       )
//     })
//   }

//   handleClearSearch = () => {
//     this.setState({ currentSearch: '' })
//   }

//   render() {
//     const { currentSearch, searchResult } = this.state,
//       locationName = searchResult.name ? searchResult.name : '',
//       locationAddress = searchResult.formatted_address ? searchResult.formatted_address : ''

//     return (
//       <div>
//         <PlacesAutocomplete
//           value={currentSearch}
//           onChange={this.handleChange.bind(this)}
//           onSelect={this.getLocation}
//         >
//           {({ getInputProps, suggestions, getSuggestionItemProps }) => {
//             return (
//               <div className='search-content-container'>
//                 <div className='search-filter-container'>
//                   <div className='search-input-container'>
//                     <input
//                       className='search-style'
//                       {...getInputProps({})}
//                       placeholder='Search Location...'
//                       id="map-search-input"
//                       type="text"
//                       title={this.state.address}
//                       onFocus={() => this.setState({ focus: true })}
//                     />
//                     {currentSearch == '' ?
//                       <img
//                         className='search-icon'
//                         src='../../../asset/Search_Solid_white_ldpi.png'
//                         alt='search'
//                       /> : <img
//                         className='clear-icon'
//                         src='../../../asset/Close-X_Thin_FFFFFF_ldpi.png'
//                         alt='clear'
//                         onClick={this.handleClearSearch}
//                       />
//                     }
//                   </div>
//                 </div>
//                 {suggestions.length > 0 && (
//                   <div>
//                     {suggestions.map(suggestion => {
//                       return (
//                         <div {...getSuggestionItemProps(suggestion, { className: 'search-result-item' })}
//                           key={suggestion.placeId}
//                         >
//                           <i className="material-icons" style={{
//                             display: 'inline-block'
//                           }}>location_on</i>
//                           {this.renderSuggestions(suggestion)}
//                         </div>
//                       )
//                     })}
//                   </div>
//                 )}
//               </div>
//             )
//           }}
//         </PlacesAutocomplete>
//         <div>
//           <p>{locationName}</p>
//           <p>{locationAddress}</p>
//           {this.state.searchResult.photos && this.state.searchResult.photos.length > 0 ?
//             (
//               <div>
//                 <p style={{
//                   width: '100%',
//                 }}>Photos</p>
//                 <div className='google-search-result-container' >
//                   {this.getPhotos()}
//                 </div>
//               </div>
//             ) : null
//           }
//         </div>
//       </div>

//     )
//   }
// }

// const mapStateToProps = state => ({
//   map: state.mapReference()
// })

// const mapDispatchToProps = dispatch => ({

// })

// export default connect(mapStateToProps, mapDispatchToProps)(LocationSearch)






import React from 'react'
import { connect } from 'react-redux'
import PlacesAutocomplete, { geocodeByAddress, getLatLng, geocodeByPlaceId } from 'react-places-autocomplete'
import isNil from 'lodash/isNil'

// Parses common coordinate input formats into { lat, lng }.
// Returns null if the input doesn't look like coordinates.
export function parseCoordinates(input) {
  const s = input.trim()

  // Plain decimal: "43.19110, -109.72003" or "43.19110 -109.72003"
  const decimal = s.match(/^(-?\d+(?:\.\d+)?)[,\s]+(-?\d+(?:\.\d+)?)$/)
  if (decimal) {
    return { lat: parseFloat(decimal[1]), lng: parseFloat(decimal[2]) }
  }

  // Hemisphere prefix: "N 43.19110 W 109.72003" or "N43.19110, W109.72003"
  const prefix = s.match(/^([NS])\s*(\d+(?:\.\d+)?)[,\s]+([EW])\s*(\d+(?:\.\d+)?)$/i)
  if (prefix) {
    return {
      lat: parseFloat(prefix[2]) * (/s/i.test(prefix[1]) ? -1 : 1),
      lng: parseFloat(prefix[4]) * (/w/i.test(prefix[3]) ? -1 : 1),
    }
  }

  // Hemisphere suffix: "43.19110N 109.72003W" or "43.19110N, 109.72003W"
  const suffix = s.match(/^(\d+(?:\.\d+)?)\s*([NS])[,\s]+(\d+(?:\.\d+)?)\s*([EW])$/i)
  if (suffix) {
    return {
      lat: parseFloat(suffix[1]) * (/s/i.test(suffix[2]) ? -1 : 1),
      lng: parseFloat(suffix[3]) * (/w/i.test(suffix[4]) ? -1 : 1),
    }
  }

  return null
}

class LocationSearch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentSearch: '',
      address: '',
      searchResult: {}
    }
    this.marker = null
    this.getLocation = this.getLocation.bind(this)
    this.setMarker = this.setMarker.bind(this)
  }

  componentDidMount() {
    const icon = '../../../../../../asset/Marker_Generic_DkGreen@1x.png'
    this.marker = new google.maps.Marker({
      options: {
        draggable: false,
        clickable: false
      },
      icon: { url: icon, scaledSize: new google.maps.Size(35, 35) }
    })
  }

  componentWillUnmount() {
    this.marker.setMap(null)
    this.marker = null
  }

  navigateTo(latLng) {
    const { map, map3d, is3d } = this.props;
    if (is3d && map3d) {
      map3d.flyTo({ center: [latLng.lng, latLng.lat], zoom: 15, duration: 1000 });
    } else if (map) {
      map.panTo(latLng);
      map.setZoom(15);
    }
  }

  setMarker() {
    const { map, is3d } = this.props;
    const { searchResult } = this.state;

    // In 3D mode the marker is a MapLibre marker — not yet implemented; skip.
    if (is3d) return;

    let location;
    if (searchResult.geometry && searchResult.geometry.location) {
      const loc = searchResult.geometry.location;
      location = typeof loc.lat === 'function' ? { lat: loc.lat(), lng: loc.lng() } : loc;
    } else if (searchResult.lat && searchResult.lng) {
      location = searchResult;
    } else {
      return;
    }

    this.marker.setPosition(location);
    if (isNil(this.marker.getMap())) {
      this.marker.setMap(map);
    }
  }

  handleChange(e) {
    this.setState({
      currentSearch: e
    });
  }

  renderSuggestions(suggestion) {
    return (
      <p
        className='search-result-entry'
        onClick={() => this.getLocation(suggestion.description, suggestion.placeId)}
        key={suggestion.index}
      >
        {suggestion.description}
      </p>
    );
  }

  getLocation(address, placeId) {
    if (!address) return;

    this.setState({ address, searching: false }, () => {
      const latLng = typeof address === 'string' ? parseCoordinates(address) : null

      if (latLng) {
        this.navigateTo(latLng);
        this.setState({ currentSearch: address, searchResult: latLng }, this.setMarker);
        return;
      }

      if (placeId) {
        const placesService = new google.maps.places.PlacesService(this.props.map);
        const request = {
          placeId,
          fields: ['name', 'formatted_address', 'geometry', 'icon', 'photos', 'address_components']
        };
        placesService.getDetails(request, (results, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            const loc = results.geometry.location;
            const latLng = typeof loc.lat === 'function' ? { lat: loc.lat(), lng: loc.lng() } : loc;
            this.navigateTo(latLng);
            this.setState({ searchResult: results }, this.setMarker);
          } else {
            console.log('Problem getting place details', status);
          }
        });
      } else {
        if (typeof address !== 'string') return;
        geocodeByAddress(address)
          .then(results => getLatLng(results[0]))
          .then(latLng => {
            this.navigateTo(latLng);
            this.setState({ currentSearch: address, searchResult: latLng }, this.setMarker);
          })
          .catch(error => console.warn('Geocode error:', error?.message || error));
      }
    })
  }

  getPhotos() {
    return this.state.searchResult.photos.map((photo, i) => {
      return (
        <div
          style={{
            backgroundImage: `url(${photo.getUrl()})`,
            backgroundSize: 'cover',
            width: '150px',
            height: '150px',
            borderRadius: '5px',
            marginTop: '10px',
            marginBottom: '10px'
          }}
          key={photo.getUrl()}></div>
      )
    })
  }

  handleClearSearch = () => {
    this.setState({ currentSearch: '' })
  }

  render() {
    const { currentSearch, searchResult } = this.state;
    const locationName = searchResult.name || '';
    const locationAddress = searchResult.formatted_address || '';

    return (
      <div>
        <PlacesAutocomplete
          value={currentSearch}
          onChange={this.handleChange.bind(this)}
          onSelect={this.getLocation}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps }) => (
            <div className='search-content-container'>
              <div className='search-filter-container'>
                <div className='search-input-container'>
                  <input
                    className='search-style'
                    {...getInputProps({})}
                    placeholder='Search Location...'
                    id="map-search-input"
                    type="text"
                    title={this.state.address}
                    onFocus={() => this.setState({ focus: true })}
                  />
                  {currentSearch === '' ? (
                    <img
                      className='search-icon'
                      src='../../../asset/Search_Solid_white_ldpi.png'
                      alt='search'
                    />
                  ) : (
                    <img
                      className='clear-icon'
                      src='../../../asset/Close-X_Thin_FFFFFF_ldpi.png'
                      alt='clear'
                      onClick={this.handleClearSearch}
                    />
                  )}
                </div>
              </div>
              {suggestions.length > 0 && (
                <div>
                  {suggestions.map(suggestion => (
                    <div
                      {...getSuggestionItemProps(suggestion, { className: 'search-result-item' })}
                      key={suggestion.placeId}
                    >
                      <i className="material-icons" style={{ display: 'inline-block' }}>
                        location_on
                      </i>
                      {this.renderSuggestions(suggestion)}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </PlacesAutocomplete>
        <div>
          <p>{locationName}</p>
          <p>{locationAddress}</p>
          {searchResult.photos?.length > 0 && (
            <div>
              <p style={{ width: '100%' }}>Photos</p>
              <div className='google-search-result-container'>
                {this.getPhotos()}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  map: state.mapReference(),
  map3d: state.mapReferenceThreed,
  is3d: state.is3dMapselected,
})

export default connect(mapStateToProps)(LocationSearch);
